import { Col, FormCheck, FormControl, FormLabel, FormSelect, Row } from "react-bootstrap";
import { useState } from "react";
import RollDice from "../dice-rolling";
import { Link } from "react-router-dom";

export default function CloseCombat() {
	const [numRolls, setNumRolls] = useState(1);
	const [attackerType, setAttackerType] = useState("Heavy Marines");
	const [targetShipSize, setTargetShipSize] = useState(1);
	const [attackingShipSize, setAttackingShipSize] = useState(1);
	const [isTowerPresent, setIsTowerPresent] = useState(false);
	const [isUsingRaven, setIsUsingRaven] = useState(false);
	const [hits, setHits] = useState({ standard: -1, super: -1 });

	const toHit: { hy: number, lt: number, ac: number, as: number, rc: number } = {
		hy: 6,
		lt: 7,
		ac: 7,
		as: 8,
		rc: 9
	}

	function RollforHits() {
		const diceRolls: number[] = RollDice(numRolls);
		let threshold: number = toHit.hy;
		let drms: number = 0;
		let hits: number = 0;
		let superHits: number = 0;

		switch (attackerType) {
			case "Light Marines":
				threshold = toHit.lt;
				break;
			case "Artillery Crews":
				threshold = toHit.ac;
				break;
			case "Archers/Slingers":
				threshold = toHit.as;
				break;
			case "Deck/Rowing Crews":
				threshold = toHit.rc;
				break;
			default:
				break;
		}

		if (isTowerPresent)
			drms += 1;
		if (isUsingRaven)
			drms += 1;
		if (targetShipSize - attackingShipSize >= 2)
			drms -= 1;

		for (var i: number = 0; i < diceRolls.length; i++) {
			if (diceRolls[i] == 1)
				continue;
			if (diceRolls[i] == 10) {
				superHits += 1;
				continue;
			}

			if (diceRolls[i] + drms >= threshold)
				hits += 1;
		}

		setHits({ standard: hits, super: superHits });
	}

	return (
		<>
			<Row>
				<Col>
					<h1>Close Combat</h1>
				</Col>
			</Row>
			{hits.standard === -1 ? null : (
				<Row className="p-3 text-center">
					<Col>
						<h1 className={hits.standard + hits.super === 0 ? "text-success" : "text-danger"}>
							{hits.standard + hits.super === 0 ? "No Hits" : `${hits.standard} hits owning player's choice and ${hits.super} hits attacking player's choice.`}
						</h1>
					</Col>
				</Row>
			)}
			<Row>
				<Col>
					<FormLabel htmlFor="num-attackers">Number of Attacking Stands</FormLabel>
					<FormControl id="num-attackers" type="number" min={1} value={numRolls} onChange={(e) => setNumRolls(parseInt(e.target.value))} />
				</Col>
				<Col>
					<FormLabel htmlFor="attacker-type">Marine/Crew Type</FormLabel>
					<FormSelect id="attacker-type" value={attackerType} onChange={(e) => setAttackerType(e.target.value)}>
						<option value="Heavy Marines">Heavy Marines</option>
						<option value="Light Marines">Light Marines</option>
						<option value="Artillery Crews">Artillery Crews</option>
						<option value="Archers/Slingers">Archers/Slingers</option>
						<option value="Deck/Rowing Crews">Deck/Rowing Crews</option>
					</FormSelect>
				</Col>
			</Row>
			<Row className="mt-3">
				<Col>
					<FormLabel htmlFor="attacker-size">Attacking Ship Size</FormLabel>
					<FormSelect id="attacker-size" value={attackingShipSize} onChange={(e) => setAttackingShipSize(parseInt(e.target.value))}>
						<option value={1}>Very Small</option>
						<option value={2}>Small</option>
						<option value={3}>Medium</option>
						<option value={4}>Large</option>
						<option value={5}>Very Large</option>
					</FormSelect>
				</Col>
				<Col>
					<FormLabel htmlFor="target-size">Target Ship Size</FormLabel>
					<FormSelect id="target-size" value={targetShipSize} onChange={(e) => setTargetShipSize(parseInt(e.target.value))}>
						<option value={1}>Very Small</option>
						<option value={2}>Small</option>
						<option value={3}>Medium</option>
						<option value={4}>Large</option>
						<option value={5}>Very Large</option>
					</FormSelect>
				</Col>
			</Row>
			<Row className="mt-3">
				<Col>
					<FormCheck type="checkbox" label="Using Raven (only applicable on first turn of Close Combat)" checked={isUsingRaven} onChange={(e) => setIsUsingRaven(e.target.checked)} />
					<FormCheck type="checkbox" label="A ship's tower is present" checked={isTowerPresent} onChange={(e) => setIsTowerPresent(e.target.checked)} />
				</Col>
			</Row>
			<Row className="mt-3">
				<Col xs={12}>
					<button className="btn btn-primary" onClick={() => RollforHits()}>Roll for Hits</button>
				</Col>
				<Col className="mt-3">
					<button className="btn btn-danger" onClick={() => setHits({ standard: -1, super: -1 })}>Clear Result</button>
				</Col>
			</Row>

		</>
	);
}